// extracted by mini-css-extract-plugin
export default {"questionContainer":"Memo_questionContainer__FX+E6","questionContent":"Memo_questionContent__aZZXZ","memoContainer":"Memo_memoContainer__kRyat","title":"Memo_title__ywKZM"};